import React, { useContext, useEffect } from "react";
// import AppContext from "../../../../Contexts/AppContext";
// import DictionaryTabs from "../../../../CustomComponents/DictionaryTabs/DictionaryTabs";
import DictionaryTabs from "../../../../components/CustomComponents/DictionaryTabs/DictionaryTabs";
import { LayerGroupSettingsElement } from "../LayerSettingsElements/LayerGroupSettingsElement";
// import { LayerFilterSelectorComponent } from "../LayerFilterSelectorComponent";
import { LayerFilterSelectorComponent } from "../LayerFilterSelectorComponent";
import { useTranslation } from "react-i18next";
import AppContext from "../../../../components/Contexts/AppContext";
const LayerSettingsComponent = ({ openDrawer }) => {
  const { t, i18n } = useTranslation("main");

  const { layersGroupsRef, dashboardsToShow, layersRef, project } =
    useContext(AppContext);
  const layersGroups = layersGroupsRef.current;

  return (
    <DictionaryTabs
      isMenu={true}
      with_gradient={true}
      tabsData={{
        visualization: {
          render: (
            <div style={{ display: "flex", flexDirection: "column" }}>
              {/* <h4>{t("layer_visualization_control")}</h4> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                {layersGroups.map((lg) => {
                  return (
                    <LayerGroupSettingsElement key={lg.id} layerGroup={lg} />
                  );
                })}
              </div>
            </div>
          ),
        },
        filters: {
          render: <LayerFilterSelectorComponent />,
          disabled: !layersGroups.some((e) => e.has_filter),
        },
        dashboard: {
          render: (
            <>
              {project?.category.startsWith("CARBON_SINK") && (
                // <div key={index}>
                <div
                  style={{
                    padding: "1.5rem",
                    borderRadius: "1.5rem",
                    backgroundColor: "white",
                  }}
                >
                  <iframe
                    // ref={iframeRef}
                    src={`${process.env.REACT_APP_API_URL}dashboard/carbon_sink_project/?lang=${i18n.language}&project_uuid=${project?.uuid}`}
                    style={{
                      width: "100%",
                      border: "none",
                      height: "100px",
                      minHeight: "50px",
                    }}
                  />
                </div>
                // </div>
              )}
              {dashboardsToShow?.map((dashboardObj, index) => {
                console.log("Procesando dashboardObj", dashboardObj);
                return (
                  <div key={index}>
                    {<dashboardObj.dashboard lang={i18n.language} />}
                  </div>
                );
              })}
            </>
          ),
          disabled: !layersGroups.some((e) => e.has_dashboard),
        },
      }}
      openDrawer={openDrawer}
    />
  );
};
export { LayerSettingsComponent };
